import _ from "lodash";
import { observer } from "mobx-react";
import type React from "react";
import { useMemo } from "react";
import { ThemeProvider } from "styled-components/macro";

import { getThemeTextSize } from "a11y-utils";

import { useDomainHandler } from "hooks/useDomainHandler";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { useProfile } from "hooks/useProfile";
import { hogesBusinessTheme } from "./hogesBusiness";
import { hogesNoordhoffTheme } from "./noordhoff";

interface ComponentWithChildren {
  children: React.ReactNode;
}

export const ThemeContainer: React.FC<ComponentWithChildren> = observer(({ children }) => {
  const { isBusinessThemeActive } = useFeatureFlags();
  const { isBusinessDomain } = useDomainHandler();
  const { userDetails } = useProfile();

  const currentTheme = useMemo(() => {
    const isBusinessTheme = isBusinessDomain() && isBusinessThemeActive;
    const baseTheme = isBusinessTheme ? hogesBusinessTheme : hogesNoordhoffTheme;

    // Build final theme based on selected size
    return _.merge({}, baseTheme, getThemeTextSize(userDetails?.textSize));
  }, [isBusinessThemeActive, userDetails?.textSize, isBusinessDomain]);

  return <ThemeProvider theme={currentTheme}>{children}</ThemeProvider>;
});
